import { render } from "./ShareWithUserForm.vue?vue&type=template&id=71db6e5c"
import script from "./ShareWithUserForm.vue?vue&type=script&lang=js"
export * from "./ShareWithUserForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__